// extracted by extract-css-chunks-webpack-plugin
module.exports = {"columns":"_3UifXY","collapse":"_1t1Xem"};